import styled from 'styled-components/macro';
import { chevrone } from '../../../assets/icons';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export const ChevronIcon = styled.img.attrs({ src: chevrone })<{
  isOpen: boolean;
}>`
  transform: ${(props) => (props.isOpen ? 'rotate(360deg)' : 'rotate(180deg)')};
  width: 16px;
  height: 16px;
`;

export const Trigger = styled(DropdownMenu.Trigger)`
  padding: 0;
  outline: none;
  border: none;
  background-color: inherit;
`;

export const Content = styled(DropdownMenu.Content)<{
  isOpen: boolean;
}>`
  width: var(--radix-dropdown-menu-trigger-width);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ced5de;
  border-radius: 8px;
  padding: 4px 0;
  box-shadow: 0 2px 4px 0 rgba(15, 23, 40, 0.04),
    0 4px 8px 0 rgba(15, 23, 40, 0.12), 0 0 10px 6px rgba(15, 23, 40, 0.04);
`;

export const Separator = styled(DropdownMenu.Separator)`
  height: 1px;
  margin: 4px 0;
  background-color: #ced5de;
`;

export const Item = styled(DropdownMenu.Item)`
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  transition: all 150ms;
  padding: 10px 12px;
  cursor: pointer;
  border: none;
  outline: none;

  :hover {
    background-color: #f2f5f8;
  }
`;
